"use client";
import React, { useEffect, useState } from "react";
import exam from "@/public/images/exam.svg";
import bookmark from "@/public/images/bookmark.svg";
import Image from "next/image";
import file from "@/public/images/file.svg";
import star from "@/public/images/star.svg";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import USER, { SelectSingleBook } from "@/redux/User";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import timePrimary from "@/public/images/timePrimary.svg";
import mark from "@/public/images/mark.svg";
import { SelectLoggedUser } from "@/redux/Auth";
import { getCookie } from "cookies-next";
import Loader from "@/components/shared/Loader";
import ErrorMessage from "@/components/shared/ErrorMessage";
import defaultImage from "@/public/images/default_image.jpg";
import GENERAL, { SelectAllAreas, SelectAllCities } from "@/redux/GENERAL";
import BuyBookDialog from "../components/BuyBookDialog";
import { toast } from "react-toastify";
import SweetAlert from "@/components/shared/SweetAlert";
// import { Metadata } from "next";

// export const metadata: Metadata = {
//   title: "الكتاب",
// };

const Page = ({ params }: { params: { id: string } }) => {
  const dispatch = useAppDispatch();
  const [hidden, setHidden] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const singleBook = useAppSelector(SelectSingleBook);

  useEffect(() => {
    dispatch(USER.thunks.doGetSingleBook({ id: params.id }))
      .then((res: any) => {
        if (res.error && res.error.message) {
          setError(res.payload.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params, dispatch]);

  const loggedUser = useAppSelector(SelectLoggedUser);
  useEffect(() => {
    const token = getCookie("Education_User_token");
    if (!token && !loggedUser.isUserLogged && !loggedUser.userToken) {
      setHidden(true);
    }
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (!params || !params.id || !singleBook) {
    return <ErrorMessage message={"يوجد خطأ حاول مره اخري."} />;
  }

  const handleAddToCart = () => {
    const token = getCookie("seveezToken");
    const tokenTwo = getCookie("Education_User_token");
    if (token && tokenTwo && token === tokenTwo && singleBook) {
      const formData = new FormData();
      formData.append("book_id", singleBook.id.toString());
      formData.append("quantity", "1");
      dispatch(USER.thunks.doAddToCart({ data: formData })).then(
        async (res: any) => {
          if (res.meta.requestStatus === "fulfilled") {
            await dispatch(USER.thunks.doGetCart({}));
            // toast.success("تمت إضافة الكتاب إلى السلة بنجاح");
            SweetAlert({
              title: "عملية ناجحة",
              text: "تمت إضافة الكتاب إلى السلة بنجاح",
              iconName: "success",
              buttonText: "حسنا",
            });
          }
          // else {
          //   toast.error("حدث خطأ أثناء إضافة الكتاب إلى السلة");
          // }
        }
      );
    } else {
      // toast.error("لابد من تسجيل الدخول لاضافة الكتاب إلي السلة");
      SweetAlert({
        title: "حدث خطأ",
        text: "لابد من تسجيل الدخول لاضافة الكتاب إلي السلة",
        iconName: "error",
        buttonText: "حسنا",
      });
    }
  };

  return (
    <div>
      <Header />
      <div className="container flex flex-col lg:flex-row gap-10 my-10">
        <div className="p-5 bg-[#323538] rounded-[15px] h-fit pb-10 border border-[#56566B] flex flex-col gap-5 w-full lg:max-w-[400px]">
          <Image
            src={singleBook?.image || defaultImage}
            alt="courseImage"
            height={372}
            width={372}
            className="mx-auto"
          />
          <div className="flex items-start justify-between gap-1">
            <div className="flex items-start gap-3">
              {singleBook?.teacher_image && (
                <Image
                  src={singleBook?.teacher_image || defaultImage}
                  alt={singleBook?.teacher_name}
                  className="rounded-[10px]"
                  width={64}
                  height={64}
                />
              )}
              <div>
                <p className="text-18 text-white font-[500]">
                  {singleBook?.teacher_name}
                </p>
                <p className="text-16 text-textColor ">
                  {singleBook?.subject?.name}
                </p>
              </div>
            </div>
            <p className="text-14 text-primaryColor font-[600] text-center py-[5px] px-2 rounded-full border border-primaryColor">
              {singleBook?.price} جنية
            </p>
          </div>
          <div className="bg-[#474A4D] rounded-[10px] flex items-center justify-between py-3 px-3 md:px-3">
            <div className="flex flex-col items-center justify-center grow">
              <Image src={exam} alt="time" />
              <p className="text-16 text-textColor font-[500]">
                {parseInt(singleBook?.quantity) > 100
                  ? "+100"
                  : singleBook?.quantity}{" "}
                متوفره
              </p>
            </div>
            <div className="flex flex-col items-center justify-center grow border-x border-[#6F7275]">
              <Image src={star} alt="star" />
              <p className="text-16 text-textColor font-[500]">
                {singleBook?.stars} نجوم
              </p>
            </div>
            <div className="flex flex-col items-center justify-center grow">
              <Image src={file} alt="file" />
              <p className="text-16 text-textColor font-[500]">
                {singleBook?.pages} صفحة
              </p>
            </div>
          </div>
          {singleBook.quantity > 0 ? (
            <button
              onClick={handleAddToCart}
              className="w-full bg-primaryColor rounded-[10px] text-16 text-black font-[500] py-3"
            >
              إضافة إلى السلة
            </button>
          ) : (
            <p className="text-center text-red-500 bg-[#474A4D] rounded-[5px] py-5 px-3">
              سيتم توفير الكتاب قريبا
            </p>
          )}

          {/* <BuyBookDialog
            bookId={params.id}
            isHidden={hidden}
          /> */}
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            {singleBook?.school_years?.map((item: any, index: number) => (
              <div key={index} className="flex items-center gap-3">
                <Image src={bookmark} alt="bookmark" />
                <p className="text-16 text-primaryColor font-[600]">
                  {item.name}
                </p>
              </div>
            ))}
          </div>
          <p className="text-40 text-white max-w-[922px]">{singleBook?.name}</p>
          <p className="text-16 text-[#BEC4E0] max-w-[922px]">
            {singleBook?.description}
          </p>
          <div className="flex items-center gap-10">
            <div className="flex items-center gap-2">
              <Image src={timePrimary} alt="time" />
              <div>
                <p className="text-14 text-white">تاريخ نشر الكتاب</p>
                <p className="text-14 text-textColor font-[300]">
                  {singleBook?.created_at?.slice(0, 10)}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-5">
            {singleBook?.features?.map((item: any, index: number) => {
              return (
                item != null && (
                  <div key={index} className="flex items-center gap-3">
                    <Image src={mark} alt="mark" />
                    <p className="text-18 text-textColor font-[300]">{item}</p>
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Page;
